import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import StudentDas1 from "../../../assets/StudentDas1.png";
import StudentDas2 from "../../../assets/StudentDas2.png";
import StudentDas3 from "../../../assets/StudentDas3.png";
import StudentCard from "./StudentCard";
import { getHitID } from "../../../config/HitIDStorage";
import axios from "axios";
import apiKey from "../../../config/apiKey";

const StudentDash = () => {
  const ID = getHitID();
  const admin = JSON.parse(localStorage.getItem("edo-admin"));
  // All Students
  const [totalCount, setTotalCount] = useState(0);
  const [uniqueTeacherCount, setUniqueTeacherCount] = useState(0);
  const [loading, setLoading] = useState(true); // Add loading state
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Start loading before data fetch
      try {
        const response = await axios.get(
          `${apiKey}/api/edolutions/admin/readnotificationsall/${ID}`,
          {
            headers: {
              Authorization: `Bearer ${admin?.token}`,
            },
          }
        );

        // Extract the data array from the response
        const notifications = response.data.data;

        // Set the total count
        setTotalCount(notifications.length);

        // Create a Set to store unique teacher_id values
        const uniqueTeacherIds = new Set();

        // Iterate through notifications and add teacher_id to the Set
        notifications.forEach((notification) => {
          uniqueTeacherIds.add(notification.teacher_id);
        });

        // Set the count of unique teacher_ids
        setUniqueTeacherCount(uniqueTeacherIds.size);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      finally {
        setLoading(false); // Stop loading after data fetch
      }
    };

    if (ID) {
      fetchData();
    }
  }, [ID, admin?.token]);

  return (
    <>
      <div>
        <div className="flex items-center xl:p-5 sm:p-0 justify-center">
          <div className="w-full border rounded-3xl shadow-xl p-5">
            <StudentCard />

            <div className="flex flex-wrap md:justify-start px-4 space-x-5 border-b-2 text-base font-medium ">
              <NavLink
                to="../studentDash"
                className={({ isActive }) =>
                  isActive
                    ? "text-blue-500 border-b-2 border-blue-500"
                    : undefined
                }
              >
                Dashboard
              </NavLink>

              <NavLink
                to=".././studentTution"
                className={({ isActive }) =>
                  isActive
                    ? "text-blue-500 border-b-2 border-blue-500"
                    : undefined
                }
              >
                Tutoring
              </NavLink>

              {/* <NavLink
                to=".././findTeacher"
                className={({ isActive }) =>
                  isActive
                    ? "text-blue-500 border-b-2 border-blue-500"
                    : undefined
                }
              >
                Find Teacher
              </NavLink> */}

              <NavLink
                to=".././studentChat"
                className={({ isActive }) =>
                  isActive
                    ? "text-blue-500 border-b-2 border-blue-500"
                    : undefined
                }
              >
                Messages
              </NavLink>
            </div>

            {/* Teachet DAshboard-------------------- */}

            <div>
              <div className="h-screen">
                <div className="mt-5 px-5">
                  <p className="text-2xl font-bold">Dashboard</p>
                </div>

                {loading ? (
                    <tr>
                      <td colSpan="9" className="py-5 px-1 text-center">
                        <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
                          <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#2DD0A5]"></div>
                          <p className="mt-4 text-lg font-semibold text-[#2dd0a5]">
                            Edolution...
                          </p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                <div className="flex flex-wrap items-center justify-center mt-10 gap-5">
                  <div className="flex items-center space-x-3 px-10 py-8 ">
                    <div>
                      {" "}
                      <img src={StudentDas1} alt="" />
                    </div>
                    <div>
                      <p className="text-sm text-[#ACACAC] font-normal">
                        Enroll Subjects
                      </p>
                      <p className="text-3xl font-semibold">{totalCount}</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3 lg:border-l-2 border-0  px-10 py-8">
                    <div>
                      {" "}
                      <img src={StudentDas2} alt="" />
                    </div>
                    <div>
                      <p className="text-sm text-[#ACACAC] font-normal">
                        Total Teacher
                      </p>
                      <p className="text-3xl font-semibold">
                        {uniqueTeacherCount}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3 lg:border-l-2 border-0 px-10 py-8">
                    <div>
                      {" "}
                      <img src={StudentDas3} alt="" />
                    </div>
                    <div>
                      <p className="text-sm text-[#ACACAC] font-normal">
                        Classes Completed
                      </p>
                      <p className="text-3xl font-semibold">0</p>
                    </div>
                  </div>
                </div>

                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentDash;
